import request from "./request.js";

export default function(list) {
  const obj = {};
  const n = list.length;
  let names;
  [`/app/live/get-live-room`, "get", "get_live_room", false]
  for (var i = 0; i < n; i++) {
    let url = list[i][0] || undefined;
    const urllist = url.split("/");
    try {
      var str = urllist.pop();
      names = str.split("?").shift();
    } catch (err) {
      console.error("url is error" + list[i]);
    }
    urllist.push(names);
    let throttle = true;
    const type = list[i][1] || "post";
    const key = list[i][2] || names;
    if(list[i][3] !== undefined){ throttle = list[i][4];};
    obj[key + 'Status'] = 1;
    obj[key] = function(query) {
      if(throttle){// 节流1.5秒
        if(obj[key + 'Status']) {
          obj[key + 'Status'] = 0;
          setTimeout(()=>{
            obj[key + 'Status'] = 1;
          },1500);
          return request[type](url, query);
        } else {
          return new Promise(()=>{});
        };
      }else{
        return request[type](url, query);
      };
    };
  }
  return obj;
}
